import {
  Component,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output
} from '@angular/core';
import { Subscription } from 'rxjs';
import { GeneralHelper } from 'src/app/helpers/general-helper';
import Company from 'src/app/model/company/company';
import { ClientCompanySelectService } from 'src/app/services/client-company-select.service';

@Component({
  selector: 'client-corner-home-page-company-selector',
  templateUrl: './client-corner-home-page-company-selector.component.html',
  styleUrls: ['./client-corner-home-page-company-selector.component.scss']
})
export class ClientCornerHomePageCompanySelector implements OnInit, OnDestroy {
  @Output()
  onSelectedCompany = new EventEmitter<Company>();

  selectableCompanies: Company[];
  selectedCompany: Company;
  clientCompanySelectSubscription: Subscription;

  constructor(private clientCompanySelectService: ClientCompanySelectService) {}

  ngOnInit(): void {
    this.selectableCompanies = this.clientCompanySelectService.getSelectableCompanies();
    this.selectedCompany = this.clientCompanySelectService.getSelectedCompany();

    this.clientCompanySelectSubscription = this.clientCompanySelectService
      .getSelectionChangedSubscribable()
      .subscribe((company: Company) =>
        this.handleInitialSelectedCompany(company)
      );
  }

  ngOnDestroy(): void {
    if (this.clientCompanySelectSubscription != null) {
      this.clientCompanySelectSubscription.unsubscribe();
    }
  }

  private handleInitialSelectedCompany(company: Company): void {
    if (company != null) {
      this.selectableCompanies = this.clientCompanySelectService.getSelectableCompanies();
      this.selectedCompany = company;
      this.onSelectedCompany.emit(this.selectedCompany);
    }
  }

  selectedCompanyChanged(): void {
    this.onSelectedCompany.emit(this.selectedCompany);
  }

  compareEntities(o1: any, o2: any): boolean {
    return GeneralHelper.compareEntities(o1, o2);
  }
}
